import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import _ from 'underscore';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Card,
	List,
	ListItem,
	Divider,
	CardActions,
	colors,
	Grid,
	Button,
} from '@mui/material';
import { SelectField } from 'components';
import { SetFormState, GenerateVmo2Report, GetVmo2ReportDates } from '../../actions/ReportsKpisActions';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(2),
	},
	value: {
		fontWeight: theme.typography.fontWeightMedium,
		align: 'center'
	},
	type: {
		fontWeight: theme.typography.fontWeightMedium,
	},
	warning: {
		color: colors.orange[500]
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Vmo2Report = (props) => {
	const { className, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.reportsKpisReducer.formState);
	const userId = useSelector((state) => state.session.user.id);
	const availableDates = useSelector((state) => state.reportsKpisReducer.vmo2ReportDates);

	

	useEffect(() => {
		dispatch(GetVmo2ReportDates(userId));
	}, []);

	const _generate = () => {
		dispatch(GenerateVmo2Report(userId, formState.values.selectedDate));
		dispatch(enqueueSnackbar({ message: 'Report Sent to Queue', options: { variant: 'info' } }));
	};

	const _handleDateChange = (value, name, type = 'date') => {
		let formattedValue = null;
		console.log(value);
		if (value) {
			if (type === 'date') {
				const date = moment(value, 'YYYY-MM-DD');
				formattedValue = date.startOf('day').format('YYYY-MM-DD');
			} else {
				formattedValue = value.format('YYYY-MM-DD HH:mm:ss');
			}
		}
		console.log(formattedValue);

		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: formattedValue
			},
			touched: {
				...formState.touched,
				[name]: true
			}
		});
	};

	const [errorState, setErrorState] = useState(false);


	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<List>
				<ListItem
					key={1}
				>
					<Grid container spacing={1}>
						<Grid item md={2} xs={2}>
							<SelectField
								id="date"
								name="date"
								hintText="Select a date"
								defaultValue={formState.values.selectedDate}
								menuItems={availableDates}
								value={formState.values.selectedDate}
								onChange={({ target: { value: v } }) => _handleDateChange(v, 'selectedDate', 'date')}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
							/>
						</Grid>
					</Grid>
				</ListItem>
			</List>
			<Divider />
			<CardActions>
				<Button
					className={classes.generate}
					onClick={_generate}
					variant="contained"
					disabled={
						formState.values.selectedDate === 'Invalid date'
						|| formState.values.selectedDate === undefined
						|| errorState
					}
				>
					Generate
				</Button>
			</CardActions>
		</Card >
	);
};

Vmo2Report.propTypes = {
	className: PropTypes.string
};

export default Vmo2Report;
